





















































































































import Reflect from "reflect-metadata";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { User } from "@/models/User";
import userService from "@/services/UserService";
import messageService from "@/services/MessageService";
import { SearchFilter } from "@/services/SearchService";
import { Project } from "@/models/Project";
import { Client } from "@/models/Client";
import clientService from "@/services/ClientService";
import * as _ from "lodash";
import projectService from "../services/ProjectService";
import { Layout } from "../models/Layout";

@Component
export default class LogFiltersDialog extends Vue {
  @Prop({ default: "" })
  filterName!: string;

  @Prop({ default: "text" })
  filterType!: string;

  @Prop({ default: "" })
  title!: string;

  filterValue: string = "";
  filterLabel!: string;
  loading: boolean = false;
  isOpen: boolean = false;

  startDateMenu = true;
  endDateMenu = false;

  startDate: string = "";
  endDate: string = "";

  /**
   * State input
   */
  selectDirty: boolean = false;
  selectedState: Partial<{ text: string; value: string }> = {};
  states = [
    {
      text: "Completado",
      value: true
    },
    {
      text: "Con error",
      value: false
    }
  ];

  @Watch("selectedState")
  onContactSelect() {
    this.filterValue = String(this.selectedState.value);
    this.filterLabel = this.selectedState.text as string;
    this.selectDirty = true;
  }

  updated() {
    (this.$refs.input as HTMLInputElement).focus();
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    this.filterValue = "";
  }

  cancelFilter() {
    this.isOpen = false;
    this.$root.$emit("filter:cancel");
  }

  applyFilter() {
    if (
      (this.filterValue && this.filterValue != "") ||
      (this.filterType == "select" && this.selectDirty)
    ) {
      this.$root.$emit("filter:apply", [
        {
          value: this.filterValue,
          key: this.filterName,
          label: this.filterLabel || this.filterValue
        }
      ]);
    }
    if (!this.filterValue && this.startDate != "" && this.endDate != "") {
      this.$root.$emit("filter:apply", [
        {
          value: this.startDate,
          key: "date_start",
          label: new Date(this.startDate).toLocaleDateString()
        },
        {
          value: this.endDate,
          key: "date_end",
          label: new Date(this.endDate).toLocaleDateString()
        }
      ]);
    }
    this.isOpen = false;
  }
}
